module.exports = __webpack_public_path__ + "static/media/pipe2_up.7ab5a22f.png";